var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { DEFORMER_MANIP_ENUM } from "../enums";
import { TextGraphicDeformer } from "./TextGraphicDeformer";
var TextGraphicOpacityDeformer = /** @class */ (function (_super) {
    __extends(TextGraphicOpacityDeformer, _super);
    function TextGraphicOpacityDeformer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._deformerType = [DEFORMER_MANIP_ENUM.COLOR];
        _this._opacities = [1.0];
        return _this;
    }
    Object.defineProperty(TextGraphicOpacityDeformer.prototype, "animatableProperties", {
        get: function () {
            return [
                'opacities',
            ];
        },
        enumerable: false,
        configurable: true
    });
    TextGraphicOpacityDeformer.prototype._uniforms = function () {
        return {
            uOpacities: this.opacities,
        };
    };
    /**
     * UpdateProperties gets called as part of the update step if the object is dirty.
     */
    TextGraphicOpacityDeformer.prototype._updateProperties = function () {
        // We need to specify the array length at shader compilation time. We can not change it once it's created!
        var expectedLength = this.parent.graphicCount;
        this._opacities = new Array(expectedLength).fill(1.0);
    };
    Object.defineProperty(TextGraphicOpacityDeformer.prototype, "opacities", {
        get: function () {
            return this._opacities;
        },
        set: function (value) {
            this._validateData(value, 1);
            this._opacities = value;
            this.parent.shader.uniforms.uOpacities = new Float32Array(value);
        },
        enumerable: false,
        configurable: true
    });
    TextGraphicOpacityDeformer.prototype._vertexHeader = function () {
        var transformCount = this.opacities.length;
        return "\n        varying float vOpacity;\n        attribute float aWeight;\n        uniform float uOpacities[".concat(transformCount, "];\n        ");
    };
    TextGraphicOpacityDeformer.prototype._vertexMain = function () {
        return "\n        int opacityTransformIndex = int(aWeight);\n        vOpacity = uOpacities[opacityTransformIndex];\n        ";
    };
    TextGraphicOpacityDeformer.prototype._fragmentHeader = function () {
        return "\n        varying float vOpacity;\n        ";
    };
    TextGraphicOpacityDeformer.prototype._fragBody = function () {
        return "\n        vec4 getColor".concat(this.index, "(vec4 inputColor) {\n            return vec4(inputColor.rgb, vOpacity);\n        }\n        ");
    };
    return TextGraphicOpacityDeformer;
}(TextGraphicDeformer));
export { TextGraphicOpacityDeformer };
